import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ChurnRiskLayer from "../components/User/ChurnRiskLayer";

const ChurnRiskPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Silent Churn" />
      <ChurnRiskLayer />
    </MasterLayout>
  );
};

export default ChurnRiskPage;
